export default __webpack_public_path__ + "static/media/f1.250c5cd2.svg";